import { createTheme } from '@mui/material';
var augmentColor = createTheme().palette.augmentColor;
export var palette = {
    primary: augmentColor({
        color: {
            main: '#00778B',
        },
    }),
    secondary: augmentColor({
        color: {
            main: '#6E6259',
            contrastText: '#fff',
        },
    }),
    error: augmentColor({
        color: {
            main: '#ff5252',
        },
    }),
    warning: augmentColor({
        color: {
            main: '#ffea00',
        },
    }),
    info: augmentColor({
        color: {
            main: '#62cae6',
        },
    }),
    success: augmentColor({
        color: {
            main: '#66bb6a',
        },
    }),
    text: {
        primary: '#6E6259',
    },
    common: {
        black: '#6E6259',
        white: '#fff',
    },
    custom: {
        normalCategory: augmentColor({
            color: { main: '#00778B' },
        }),
        mildCategory: augmentColor({
            color: { main: '#64ACB8' },
        }),
        moderateCategory: augmentColor({
            color: { main: '#B0D5DB' },
        }),
        grey: augmentColor({
            color: { main: '#EDEEEE' },
        }),
    },
};
